import { useState } from "react"

import { parseErrorAsObj } from "../../../../errors/errorProcessors"
import { IAppError } from "../../../../errors/errorTypes"
import { snackbar } from "../../../../utils/general/generalUtils"
import { patchClientProtected } from "../../clients/clients"
import { DNO_READ_COMMENTS, INSTALLER_READ_COMMENTS } from "../../urls/hybrid"

interface IReadApplicationCommentHook {
    isSending: boolean
    error: IAppError | undefined
    patchResponse: (
        applicationId: string,
        read: boolean,
        isDno: boolean,
        resetSwitchOnFail?: () => void
    ) => Promise<void>
}

const useReadApplicationComment = (): IReadApplicationCommentHook => {
    const [isSending, setIsSending] = useState(false)
    const [error, setError] = useState<IAppError | undefined>(undefined)

    const patchResponse = async (
        applicationId: string,
        read: boolean,
        isDno: boolean,
        resetSwitchOnFail?: () => void
    ): Promise<void> => {
        try {
            let url
            setIsSending(true)
            if (isDno) {
                url = DNO_READ_COMMENTS(applicationId)
            } else {
                url = INSTALLER_READ_COMMENTS(applicationId)
            }
            await patchClientProtected(url, { read })
            snackbar(
                `Comment read status updated to ${read ? "read" : "unread"}.`,
                "success"
            )
        } catch (err) {
            if (resetSwitchOnFail) {
                resetSwitchOnFail()
            }
            const errorObj = parseErrorAsObj(err)
            setError(errorObj)
            snackbar(
                "Failed to update comment read status. Please try again.",
                "warning"
            )
        } finally {
            setIsSending(false)
        }
    }

    return {
        error,
        isSending,
        patchResponse,
    }
}

export default useReadApplicationComment
